define.alias("ember-truth-helpers/helpers/lt", "settings/helpers/lt");